export default __webpack_public_path__ + "static/applet-02-set-2-1d145c7662c7c877fed1dfee9a5ec881.webp";